import {combineReducers} from 'redux';

import {SelectionSliceFor} from '../../../store/SelectionSliceFor';

const entityKey = 'billing-providers';

const selectionSlice = SelectionSliceFor(entityKey);

export const {
    addToSelection,
    removeFromSelection,
    clearSelection,
} = selectionSlice.actions;

export const BillingProvidersReducer = combineReducers({
    selection: selectionSlice.reducer,
});
